
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "Dot",
  props: {
    index: {
      type: Number,
      required: true
    },
    isCorrect: {
      type: Boolean,
      default: false
    },
    isIncorrect: {
      type: Boolean,
      default: false
    },
    isCorrection: {
      type: Boolean,
      default: false
    },
    isUnanswered: {
      type: Boolean,
      default: false
    },
    isCurrent: {
      type: Boolean,
      default: false
    }
  },
  emits: ["select"],
  setup(props, { emit }) {
    const classes = computed(() => ({
      correct: props.isCorrect,
      incorrect: props.isIncorrect,
      correction: props.isCorrection,
      unanswered: props.isUnanswered,
      "is-current": props.isCurrent
    }));

    const handleClick = () => {
      emit("select", props.index);
    };

    return {
      classes,
      handleClick
    };
  }
});
